var _idx, _type;
// Helpers
const splitCsv = (s)=>typeof s === "string" ? s.split(",").map((x)=>x.trim()).filter(Boolean) : [];
const ensureArray = (v)=>Array.isArray(v) ? v : [];
const asStr = (v, fallback = "")=>typeof v === "string" ? v : fallback;
const ensureAbsoluteUrl = (u)=>{
    const s = asStr(u, "");
    if (!s) return undefined;
    if (/^https?:\/\//i.test(s)) return s;
    if (/^[\w.-]+\.[a-z]{2,}/i.test(s)) return `https://${s}`;
    return s;
};
const normalizeSocial = (val, platform)=>{
    const s = asStr(val, "");
    if (!s) return undefined;
    if (/^https?:\/\//i.test(s)) return s;
    const base = {
        facebook: "https://www.facebook.com/",
        twitter: "https://twitter.com/",
        instagram: "https://instagram.com/"
    };
    return `${base[platform]}${s}`;
};
const indexIncludedByType = (included)=>{
    const idx = {};
    included == null ? void 0 : included.forEach((r)=>{
        ((_idx = idx)[_type = r.type] || (_idx[_type] = [])).push({
            id: r.id,
            attributes: r.attributes
        });
    });
    return idx;
};
export default function normalizeStore(res) {
    var ref, ref1, ref2;
    const d = res.data ?? {};
    const a = d.attributes ?? {};
    const rel = d.relationships ?? {};
    // Required values
    const name = asStr(a.name, "");
    const url = ensureAbsoluteUrl(a.url) || "";
    const title = asStr(a.seo_title, "") || name;
    const description = asStr(a.meta_description, "");
    const keywords = asStr(a.meta_keywords, "");
    // currency/locale
    const defaultCurrency = asStr(a.default_currency, "");
    const supportedCurrencies = splitCsv(a.supported_currencies);
    const currency = {
        default: defaultCurrency,
        supported: supportedCurrencies.length ? supportedCurrencies : defaultCurrency ? [
            defaultCurrency
        ] : []
    };
    const defaultLocale = asStr(a.default_locale, "");
    const supportedLocales = splitCsv(a.supported_locales);
    const locale = {
        default: defaultLocale,
        supported: supportedLocales.length ? supportedLocales : defaultLocale ? [
            defaultLocale
        ] : []
    };
    // Objects present but without keys if there is no data 
    const social = {
        ...normalizeSocial(a.facebook, "facebook") ? {
            facebook: normalizeSocial(a.facebook, "facebook")
        } : {},
        ...normalizeSocial(a.twitter, "twitter") ? {
            twitter: normalizeSocial(a.twitter, "twitter")
        } : {},
        ...normalizeSocial(a.instagram, "instagram") ? {
            instagram: normalizeSocial(a.instagram, "instagram")
        } : {}
    };
    const contact = {
        ...asStr(a.customer_support_email) ? {
            email: asStr(a.customer_support_email)
        } : {},
        ...asStr(a.address) ? {
            address: asStr(a.address)
        } : {},
        ...asStr(a.contact_phone) ? {
            phone: asStr(a.contact_phone)
        } : {}
    };
    const assets = {
        ...asStr(a.logo) ? {
            logo: asStr(a.logo)
        } : {},
        ...asStr(a.mailer_logo) ? {
            mailerLogo: asStr(a.mailer_logo)
        } : {},
        ...asStr(a.favicon_path) ? {
            faviconPath: asStr(a.favicon_path)
        } : {}
    };
    // Relationships (optional)
    let defaultCountry;
    const dcRel = (ref = rel["default_country"]) == null ? void 0 : ref.data;
    if (dcRel == null ? void 0 : dcRel.id) {
        defaultCountry = {
            id: dcRel.id
        };
        const match = (res.included || []).find((r)=>r.type === "country" && r.id === dcRel.id);
        if (match) {
            const attrs = match.attributes || {};
            const iso = asStr(attrs.iso);
            const cname = asStr(attrs.name);
            if (iso) defaultCountry.iso = iso;
            if (cname) defaultCountry.name = cname;
        }
    }
    const cmsPageIds = ensureArray((ref1 = rel["cms_pages"]) == null ? void 0 : ref1.data).map((x)=>x.id);
    const menuIds = ensureArray((ref2 = rel["menus"]) == null ? void 0 : ref2.data).map((x)=>x.id);
    const includedIndex = indexIncludedByType(res.included);
    const hasIncludedIndex = Object.keys(includedIndex).length > 0;
    return {
        id: asStr(d.id, ""),
        name,
        url,
        title,
        description,
        keywords,
        currency,
        social,
        locale,
        contact,
        assets,
        ...defaultCountry ? {
            defaultCountry
        } : {},
        ...cmsPageIds.length ? {
            cmsPageIds
        } : {},
        ...menuIds.length ? {
            menuIds
        } : {},
        ...hasIncludedIndex ? {
            includedIndex
        } : {}
    };
};
